// extracted by mini-css-extract-plugin
export default {"avatar":"OrderInfo_avatar__Gz1-l","avatarTitle":"OrderInfo_avatarTitle__RIl6j","profit":"OrderInfo_profit__UpUGT"};